/*
 * @category  Puma
 * @author    Beshoy Samuel <info@scandiweb.com>
 * @license   http://opensource.org/licenses/OSL-3.0 The Open Software License 3.0 (OSL-3.0)
 * @copyright Copyright (c) 2023 Scandiweb, Inc (https://scandiweb.com)
 */

export class CheckoutShippingContainerPlugin {
    aroundContainerFunctions = (originalMember, instance) => ({
        ...originalMember,
        onNationalIdNumberChange: instance.props.onNationalIdNumberChange
    });
}

const { aroundContainerFunctions } = new CheckoutShippingContainerPlugin();

export const config = {
    'Component/CheckoutShipping/Container': {
        'member-property': {
            containerFunctions: aroundContainerFunctions
        }
    }
};

export default config;
